import { DownloadButton } from "@/components/buttons/DownloadButton";
import { downloadCsvFile } from "@/features/custom_downloads";
import { HacsOmDragger, HacsOmUploadData } from "@/features/hacs";
import { buildLocationsExampleCsv } from "@/tools/aggregate/portfolio-export/constants";
import { Collapse } from "antd";
import { useTranslation } from "react-i18next";
import { SEVERITIES_TEMPLATE_HEADERS } from "../constants";
interface SeveritiesUploadFormProps {
  onFileSelected: (data: HacsOmUploadData) => void;
  maxRows: number;
}
export const SeveritiesUploadForm = ({
  onFileSelected,
  maxRows
}: SeveritiesUploadFormProps) => {
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "comprehensive.severities.newRunModal"
  });
  return <div data-sentry-component="SeveritiesUploadForm" data-sentry-source-file="SeveritiesUploadForm.tsx">
      <HacsOmDragger onDataChange={data => data && onFileSelected(data)} prompt="Select .csv file" data-sentry-element="HacsOmDragger" data-sentry-source-file="SeveritiesUploadForm.tsx" />

      <p className="mt-4 text-sm">
        {t("upload.blurb")} You can also download a portfolio&apos;s or Large Site&apos;s locations in this format from
        the Downloads panel of its results.
      </p>
      <div className="pt-4">
        <DownloadButton type="primary" onClick={() => downloadCsvFile(buildLocationsExampleCsv(SEVERITIES_TEMPLATE_HEADERS), {
        filename: "Severities Upload Template.csv"
      })} data-sentry-element="DownloadButton" data-sentry-source-file="SeveritiesUploadForm.tsx">
          Download Template
        </DownloadButton>
      </div>

      <Collapse rootClassName="mt-4 bg-surface border-gray-200 [&_.ant-collapse-item]:!border-gray-200 [&_.ant-collapse-content]:!border-none" className="prose my-2 [&_.ant-collapse-header-text]:mt-auto [&_.ant-collapse-header-text]:text-sm" size="small" expandIconPlacement="end" items={[{
      key: "uploadRequirements",
      label: "Upload Requirements",
      classNames: {
        body: "!px-4",
        header: "!px-4"
      },
      children: <ul className="mt-0 *:m-0 *:mb-1">
                <li>
                  <span className="font-bold">Rows: </span>
                  Each row is one location. You can upload up to {maxRows.toLocaleString()} rows per run.
                </li>
                <li>
                  <span className="font-bold">Column Headers: </span>
                  Only use the headers in the template: {SEVERITIES_TEMPLATE_HEADERS.join(", ")}.
                </li>
                <li>
                  <span className="font-bold">User IDs: </span>
                  IDs are optional but must be unique within the file.
                </li>
                <li>
                  <span className="font-bold">Coordinates: </span>
                  Latitude and longitude are required, in decimal degrees. Latitude must be between -90 and 90, and
                  longitude between -180 and 180.
                </li>
              </ul>
    }]} data-sentry-element="Collapse" data-sentry-source-file="SeveritiesUploadForm.tsx" />
    </div>;
};